import type {
  FetchSalesRuleListParams,
  SalesRule
} from 'Services/ProductManagement/Features/SalesRule/types'
import type { ListResponse } from 'Services/ProductManagement/types'
import { createBaseApi } from 'Util/ApiClient'

export const salesRuleApi = createBaseApi({
  reducerPath: 'salesRuleApi',
  tagTypes: ['SalesRule'],
  keepUnusedDataFor: 10
}).injectEndpoints({
  endpoints: builder => ({
    getSalesRules: builder.query<ListResponse<SalesRule>, FetchSalesRuleListParams>({
      query: (params: FetchSalesRuleListParams) => ({
        url: 'api/v1/extension-sales-rule/',
        params
      }),
      providesTags: result =>
        result
          ? [
              ...result.resources.map(({ id }) => ({ type: 'SalesRule', id }) as const),
              { type: 'SalesRule', id: 'LIST' }
            ]
          : [{ type: 'SalesRule', id: 'LIST' }]
    }),
    getSingleSalesRule: builder.query<SalesRule, string>({
      query: id => `api/v1/extension-sales-rule/${id}/`,
      providesTags: (_result, _error, id) => [{ type: 'SalesRule', id }]
    }),
    createSingleSalesRule: builder.mutation<SalesRule, Partial<SalesRule>>({
      query: data => ({
        url: 'api/v1/extension-sales-rule/',
        method: 'POST',
        body: data
      }),
      invalidatesTags: [{ type: 'SalesRule', id: 'LIST' }]
    }),
    updateSingleSalesRule: builder.mutation<SalesRule, { id: string } & Partial<SalesRule>>({
      query: ({ id, ...data }) => ({
        url: `api/v1/extension-sales-rule/${id}/`,
        method: 'PUT',
        body: data
      }),
      invalidatesTags: (_result, _error, { id }) => [{ type: 'SalesRule', id }]
    }),
    deleteSingleSalesRule: builder.mutation<Record<string, never>, string>({
      query: id => ({
        url: `api/v1/extension-sales-rule/${id}/`,
        method: 'DELETE'
      }),
      invalidatesTags: () => [{ type: 'SalesRule', id: 'LIST' }]
    })
  })
})

export const {
  useGetSalesRulesQuery,
  useGetSingleSalesRuleQuery,
  useCreateSingleSalesRuleMutation,
  useUpdateSingleSalesRuleMutation,
  useDeleteSingleSalesRuleMutation
} = salesRuleApi
